import {DeleteForeverOutlined} from "@mui/icons-material";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {child, DatabaseReference, set} from "firebase/database";
import {useCallback, useState} from "react";
import {useAuthState, useDeleteUser} from "react-firebase-hooks/auth";
import {useHistory} from "react-router-dom";
import {auth, nodeRefs} from "../firebase/index.js";
import {red_900} from "./js/APXTheme.js";


const dbNodeRefs: DatabaseReference[] = nodeRefs || [];


export default function APXDeleteAccount() {
	  const [show1stDialog, setShow1stDialog] = useState(false);
	  const [show2ndDialog, setShow2ndDialog] = useState(false);
	  
	  const [progressText, setProgressText] = useState("");
	  const [showDeletionInProgressDialog, setShowDeletionInProgressDialog] = useState(false);
	  
	  const uid = useAuthState(auth)[0]?.uid;
	  const [deleteUser, loading, error] = useDeleteUser(auth);
	  const history = useHistory();
	  
	  const doDeletion = useCallback((onComplete: ()=>void) => {
			 if ( /*TRUTHY->*/ !!uid) {
					
					const dataDeletionPromises = dbNodeRefs.map((nodeRef: DatabaseReference) => set(child(nodeRef, `${uid}`), null));
					
					Promise.allSettled(dataDeletionPromises)
							  .finally(
										 () => {
												
												setProgressText("Data deleted. Attempting to delete account.");
												
												const ERROR_CODE_REQUIRES_RECENT_LOGIN = "auth/requires-recent-login";
												
												deleteUser()
														  .then(
																	 (value) => {
																			if (value) {
																				  setProgressText("Account deleted successfully.");
																				  history.replace("/");
																			} else {
																				  if (/*TRUTHY->*/ !!error) {
																						 if (error.code === ERROR_CODE_REQUIRES_RECENT_LOGIN) {
																								setProgressText("Clean-up required. Please login again to delete account.");
																						 } else {
																								setProgressText("Please login again to delete account.");
																						 }
																						 setTimeout(() => auth.signOut().finally(() => history.replace("/")), 1000);
																				  }
																			}
																	 }
														  )
														  .finally(
																	 () => setTimeout(() => onComplete(), 1000)
														  );
										 }
							  );
			 }
	  }, [dbNodeRefs, uid, error, deleteUser]);
	  
	  return (
				 <>
						<Tooltip title={"Delete Account"}>
							  <IconButton size={"large"} color={"primary"} onClick={() => setShow1stDialog(true)}><DeleteForeverOutlined/></IconButton>
						</Tooltip>
						
						<Dialog open={show1stDialog} fullWidth
								  onClose={(event, reason) => {
										 if (reason === "escapeKeyDown" || reason === "backdropClick") return;
										 setShow1stDialog(false);
								  }}>
							  <DialogTitle sx={{p: 3, color: red_900}}>
									 Are you sure you want to delete your account?
							  </DialogTitle>
							  <DialogContent dividers>
									 <Typography sx={{color: red_900}}>
											This will delete your account completely, including all your data.
											<br/>
											This is IRREVERSIBLE. Continue only if you really want to delete.
									 </Typography>
							  </DialogContent>
							  <DialogActions>
									 <Button variant={"contained"} onClick={() => setShow1stDialog(false)}>Exit</Button>
									 <Button onClick={() => {
											setShow1stDialog(false);
											setShow2ndDialog(true);
									 }}>Continue</Button>
							  </DialogActions>
						</Dialog>
						
						<Dialog open={show2ndDialog} fullWidth
								  onClose={(event, reason) => {
										 if (reason === "escapeKeyDown" || reason === "backdropClick") return;
										 setShow2ndDialog(false);
								  }}>
							  <DialogTitle sx={{p: 3, color: red_900}}>
									 Confirm to delete your account and all your data.
							  </DialogTitle>
							  <DialogActions>
									 <Button variant={"contained"} onClick={() => setShow2ndDialog(false)}>Exit</Button>
									 <Button onClick={() => {
											setShow2ndDialog(false);
											setShowDeletionInProgressDialog(true);
											/* DELETION */
											doDeletion(() => setShowDeletionInProgressDialog(false));
											/* DELETION */
									 }}>Confirm</Button>
							  </DialogActions>
						</Dialog>
						
						<Dialog open={showDeletionInProgressDialog} fullScreen
								  onClose={(event, reason) => {
										 if (reason === "escapeKeyDown" || reason === "backdropClick") return;
										 setShowDeletionInProgressDialog(false);
								  }}>
							  <Stack alignItems={"center"} p={4} spacing={4} justifyContent={"center"} sx={{width: "100%", height: "100%"}}>
									 <Typography sx={{color: red_900}} align={"center"}>
											Deleting all your data and account.<br/>This may take a while.<br/><br/>{progressText}
									 </Typography>
									 <CircularProgress/>
							  </Stack>
						</Dialog>
				 </>
	  );
}